import { getFindAllTaskListItemsQueryKey, getFindAllTasksQueryKey } from '@api';
import { useInvalidateQuery } from '@common';
import { useWebSocketContext } from '@hypeit-gmbh/hypeit-ui-core';

export const useTaskWebSocket = (): void => {
  const tasksListItemsQueryKey = getFindAllTaskListItemsQueryKey();
  const tasksQueryKey = getFindAllTasksQueryKey();
  const { invalidateQuery: invalidateTasksListItemsQuery } = useInvalidateQuery(
    tasksListItemsQueryKey
  );
  const { invalidateQuery: invalidateTasksQuery } =
    useInvalidateQuery(tasksQueryKey);

  useWebSocketContext({
    subscribe: '/task-service-v1/tasks-list-items',
    onMessage: () => {
      invalidateTasksListItemsQuery();
    },
  });

  useWebSocketContext({
    subscribe: '/task-service-v1/tasks',
    onMessage: () => {
      invalidateTasksQuery();
    },
  });
};
